module.exports = __webpack_public_path__ + "img/time_dot.a19ec2e4.png";